


import { defineComponent, ref } from '@vue/composition-api';
import TimeSlider from '@/components/lib/TimeSlider/index.vue';

const MINUTE_OFFSETS = [-180, -120, -60, 0, 60];
const formatOffsetLabel = (m: number) => m === 0 ? '現在' : `${m > 0 ? '+' : '-'}${Math.abs(m) / 60}h`;
const TIME_LABELS: ReadonlyArray<string> = MINUTE_OFFSETS.map(formatOffsetLabel);
const WEATHER_RADAR_JMA_URL =
  'https://www.jma.go.jp/bosai/nowc/#zoom:9/lat:35.670685/lon:139.781799/colordepth:deep/elements:amds_rain10m&hrpns';

interface TimeChangeEvent {
  index: number;
  value: string;
}

export default defineComponent({
  components: {
    TimeSlider,
  },
  emits: ['enabled-change', 'time-change'],

  setup(_props, { emit }) {
    const isWeatherRadarEnabled = ref<boolean>(false);
    const selectedTimeIndex = ref<number>(3);

    const onWeatherRadarToggle = (): void => {
      isWeatherRadarEnabled.value = !isWeatherRadarEnabled.value;
      emit('enabled-change', {
        isEnabled: isWeatherRadarEnabled.value,
        selectedTimeIndex: selectedTimeIndex.value,
        minuteOffsets: MINUTE_OFFSETS,
      });
    };
    const onTimeChange = (event: TimeChangeEvent): void => {
      selectedTimeIndex.value = event.index;
      emit('time-change', event);
    };

    return {
      timeLabels: TIME_LABELS,
      weatherRadarJmaUrl: WEATHER_RADAR_JMA_URL,
      isWeatherRadarEnabled,
      selectedTimeIndex,
      onWeatherRadarToggle,
      onTimeChange,
    };
  },
});
